import { isDefined } from './bids';
import { ALL, DGC_ORDERS_DEFAULT_PAGE_NUM, DGC_ORDERS_PAGE_SIZE } from 'shared/consts/dgcOrders';
import { DgcOrdersRequestParams, DgcOrdersUrlParams } from 'shared/types/dgcOrders';

// The API contract requires _page >= 1, so anything non-integer or out of range falls back.
export const normalizeDgcPageNum = (value: unknown): number => {
  if (!isDefined(value)) {
    return DGC_ORDERS_DEFAULT_PAGE_NUM;
  }

  const parsed = Number(value);

  return Number.isInteger(parsed) && parsed >= 1 ? parsed : DGC_ORDERS_DEFAULT_PAGE_NUM;
};

export const getDgcOrdersParams = (params: DgcOrdersUrlParams): DgcOrdersRequestParams => {
  const pageSize =
    isDefined(params?.pageSize) && +(params?.pageSize as string) > 0
      ? +(params?.pageSize as string)
      : DGC_ORDERS_PAGE_SIZE;

  return {
    _page: String(normalizeDgcPageNum(params?.pageNum)),
    _limit: String(pageSize),
    _cardType: params?.cardType,
    _deliveryMethod: params?.deliveryMethod,
    _paymentType: params?.paymentType,
    _clientName: params?.clientName,
    _orderRef: params?.orderRef,
    _createdFrom: params?.createdDateFrom,
    _createdTo: params?.createdDateTo,
    _sortBy: params?.sortBy,
    _sortDir: params?.sortDir,
    ...(isDefined(params?.status) && params.status !== ALL && { _status: params.status }),
  };
};
